import * as colors from './baseColors';
import { ThemeColors } from 'theme/colors/colors';

const darkBaseColors = {
  ...colors,
  royalBase: '#248FFF',
  blazeBase: '#FF8E3C',
  lilacBase: '#C878DC',
};

const colorPrimary = darkBaseColors.royalBase;
const colorSecondary = darkBaseColors.smokeLight;
const colorDanger = darkBaseColors.watermelonBase;
const colorSuccess = darkBaseColors.appleBase;
const colorWarning = darkBaseColors.blazeBase;
const colorInternal = darkBaseColors.sunglowBase;

export const textWhite = darkBaseColors.white;
export const textLighter = darkBaseColors.smokeBase;
export const textLight = darkBaseColors.smokeLighter;
export const textBase = darkBaseColors.smokeLightest;
export const textDark = darkBaseColors.smokeLightest;
export const textPrimary = darkBaseColors.royalBase;
export const textSuccess = darkBaseColors.appleDarker;
export const textWarning = darkBaseColors.blazeBase;
export const textDanger = darkBaseColors.watermelonBase;
export const textInternal = darkBaseColors.sunglowDarker;

export const borderWhite = darkBaseColors.chimneyBase;
export const borderLightest = darkBaseColors.chimneyLight;
export const borderLighter = darkBaseColors.chimneyLighter;
export const borderLight = darkBaseColors.chimneyLightest;
export const borderBase = darkBaseColors.chimneyDarkest;
export const borderDark = darkBaseColors.chimneyDarkest;
export const borderDarker = darkBaseColors.chimneyDarkest;
export const borderDarkest = darkBaseColors.chimneyDarkest;
export const borderPrimary = darkBaseColors.royalBase;
export const borderSuccess = darkBaseColors.appleBase;
export const borderWarning = darkBaseColors.blazeBase;
export const borderDanger = darkBaseColors.watermelonBase;
export const borderInternal = darkBaseColors.sunglowBase;

export const backgroundWhite = darkBaseColors.chimneyDark;
export const backgroundLightest = darkBaseColors.chimneyDark;
export const backgroundLighter = darkBaseColors.chimneyLight;
export const backgroundLight = darkBaseColors.chimneyLight;
export const backgroundBase = darkBaseColors.chimneyLighter;
export const backgroundDark = darkBaseColors.chimneyLight;
export const backgroundDarker = darkBaseColors.chimneyLightest;
export const backgroundDarkest = darkBaseColors.smokeDarkest;
export const backgroundPrimary = darkBaseColors.royalBase;
export const backgroundPrimaryLight = darkBaseColors.royalDarker;
export const backgroundPrimaryLighter = darkBaseColors.chimneyLight;
export const backgroundSuccess = darkBaseColors.appleBase;
export const backgroundWarning = darkBaseColors.blazeBase;
export const backgroundInternal = darkBaseColors.sunglowBase;
export const backgroundDanger = darkBaseColors.watermelonBase;
export const backgroundDangerLighter = darkBaseColors.chimneyLight;

export const iconWhite = darkBaseColors.white;
export const iconLighter = darkBaseColors.smokeBase;
export const iconLight = darkBaseColors.smokeLighter;
export const iconBase = darkBaseColors.smokeLightest;
export const iconDark = darkBaseColors.smokeLightest;
export const iconPrimary = darkBaseColors.royalBase;
export const iconSuccess = darkBaseColors.appleBase;
export const iconDanger = darkBaseColors.watermelonBase;
export const iconWarning = darkBaseColors.blazeBase;
export const iconInternal = darkBaseColors.sunglowBase;
export const iconGuest = darkBaseColors.blazeBase;
export const iconVisit = darkBaseColors.lilacBase;

export const disabled = colors.chimneyLightest;
export const disabledBackground = colors.chimneyLight;

// one offs to change after all colors are done above

const darkColors: ThemeColors = {
  black: darkBaseColors.black,
  white: darkBaseColors.white,
  primary: colorPrimary,
  secondary: colorSecondary,
  danger: colorDanger,
  success: colorSuccess,
  warning: colorWarning,
  internal: colorInternal,

  backgroundColorBody: darkBaseColors.chimneyDark,
  backgroundColorPaper: darkBaseColors.chimneyDark,
  //below are the primary things to use
  textWhite,
  textLighter,
  textLight,
  textBase,
  textDark,
  textPrimary,
  textSuccess,
  textWarning,
  textDanger,
  textInternal,

  borderWhite,
  borderLightest,
  borderLighter,
  borderLight,
  borderBase,
  borderDark,
  borderDarker,
  borderDarkest,
  borderPrimary,
  borderSuccess,
  borderWarning,
  borderDanger,
  borderInternal,

  backgroundWhite,
  backgroundLightest,
  backgroundLighter,
  backgroundLight,
  backgroundBase,
  backgroundDark,
  backgroundDarker,
  backgroundDarkest,
  backgroundPrimary,
  backgroundPrimaryLight,
  backgroundPrimaryLighter,
  backgroundSuccess,
  backgroundWarning,
  backgroundDanger,
  backgroundDangerLighter,
  backgroundInternal,

  iconWhite,
  iconLighter,
  iconLight,
  iconBase,
  iconDark,
  iconPrimary,
  iconSuccess,
  iconDanger,
  iconWarning,
  iconInternal,
  iconGuest,
  iconVisit,

  disabled,
  disabledBackground,
};

export default darkColors;
